import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/icons/back-arrow-primary.svg'
import _imports_1 from '@/assets/icons/forward-arrow-primary.svg'


const _hoisted_1 = { class: "flex flex-col h-screen" }
const _hoisted_2 = { class: "flex-grow bg-background shadow-inner" }
const _hoisted_3 = { class: "container py-8" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_6 = { class: "flex flex-row items-center justify-between" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Back")
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "flex flex-row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Previous")
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Next")
], -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 0,
  class: "flex flex-row mt-8"
}
const _hoisted_15 = {
  key: 0,
  class: "flex flex-col bg-white rounded-2xl p-8 mr-4"
}
const _hoisted_16 = {
  key: 0,
  class: "flex flex-row items-center justify-center rounded-full bg-black px-6 py-2 mt-4 text-center border border-black border-2"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "text-white mr-2" }, "Monthly net salary: ", -1)
const _hoisted_18 = {
  key: 0,
  class: "text-white uppercase"
}
const _hoisted_19 = {
  key: 1,
  class: "text-white uppercase"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "h-px bg-gray-300 w-full my-4" }, null, -1)
const _hoisted_21 = { class: "flex flex-col" }
const _hoisted_22 = { class: "flex flex-row" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "w-32" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Job email")
], -1)
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "h-px bg-gray-300 w-full my-4" }, null, -1)
const _hoisted_27 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Contact details", -1)
const _hoisted_29 = { class: "flex flex-col mt-2" }
const _hoisted_30 = { class: "flex flex-row" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "w-32" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Address")
], -1)
const _hoisted_32 = {
  key: 0,
  class: "capitalize"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 mt-2" }, null, -1)
const _hoisted_34 = { class: "flex flex-col mt-2" }
const _hoisted_35 = { class: "flex flex-row" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "w-32" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Phone")
], -1)
const _hoisted_37 = {
  key: 0,
  class: "capitalize"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 mt-2" }, null, -1)
const _hoisted_39 = { class: "flex flex-col mt-2" }
const _hoisted_40 = { class: "flex flex-row" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "w-32" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Personal Email")
], -1)
const _hoisted_42 = { key: 0 }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 mt-2" }, null, -1)
const _hoisted_44 = { class: "flex flex-col mt-4" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Additional information", -1)
const _hoisted_46 = { class: "flex flex-col mt-2" }
const _hoisted_47 = { class: "flex flex-row" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "w-32" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Start date")
], -1)
const _hoisted_49 = {
  key: 0,
  class: "capitalize"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 mt-2" }, null, -1)
const _hoisted_51 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-col mt-2\"><div class=\"flex flex-row\"><div class=\"w-32\"><span class=\"text-gray-500\">PTO days</span></div><span class=\"capitalize\"> 0 </span></div><div class=\"h-px w-full bg-gray-300 mt-2\"></div></div><div class=\"flex flex-col mt-2\"><div class=\"flex flex-row\"><div class=\"w-32\"><span class=\"text-gray-500\">PTO remaining days</span></div><span> 20 </span></div><div class=\"h-px w-full bg-gray-300 mt-2\"></div></div>", 2)
const _hoisted_53 = {
  key: 2,
  class: "flex flex-col mt-4"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Summary", -1)
const _hoisted_55 = { class: "w-80 text-gray-500" }
const _hoisted_56 = {
  key: 1,
  class: "flex flex-col flex-grow bg-white rounded-2xl p-8"
}
const _hoisted_57 = { class: "flex flex-row" }
const _hoisted_58 = ["onClick"]
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 mt-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_ErrorState = _resolveComponent("ErrorState")!
  const _component_UserCard = _resolveComponent("UserCard")!
  const _component_DateFormatter = _resolveComponent("DateFormatter")!
  const _component_Onboarding = _resolveComponent("Onboarding")!
  const _component_Timeline = _resolveComponent("Timeline")!
  const _component_Position = _resolveComponent("Position")!
  const _component_PaymentBreakdown = _resolveComponent("PaymentBreakdown")!
  const _component_PaymentInformation = _resolveComponent("PaymentInformation")!
  const _component_Files = _resolveComponent("Files")!
  const _component_EmergencyContacts = _resolveComponent("EmergencyContacts")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Navbar),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_Spinner, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_ctx.error)
                ? (_openBlock(), _createBlock(_component_ErrorState, { key: 0 }))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/talent'))),
                        class: "btn-outline-sm"
                      }, _hoisted_8),
                      _createElementVNode("div", _hoisted_9, [
                        (_ctx.previous_id !== '')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push(`/talent/${_ctx.previous_id}/job`))),
                              class: _normalizeClass(["btn-outline-sm", { 'mr-2': _ctx.next_id }])
                            }, _hoisted_11, 2))
                          : _createCommentVNode("", true),
                        (_ctx.next_id !== '')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push(`/talent/${_ctx.next_id}/job`))),
                              class: _normalizeClass(["btn-outline-sm", { 'ml-2': _ctx.previous_id }])
                            }, _hoisted_13, 2))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (_ctx.user.meta)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          (_ctx.user.talent)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createVNode(_component_UserCard, {
                                  id: _ctx.user.talent.id,
                                  firstName: _ctx.user.talent.first_name,
                                  lastName: _ctx.user.talent.last_name,
                                  position: _ctx.user.talent.job_title,
                                  class: "mt-4"
                                }, null, 8, ["id", "firstName", "lastName", "position"]),
                                (_ctx.user.talent.salary)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                      _hoisted_17,
                                      (_ctx.currency === 'usd')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, " $" + _toDisplayString((
                        (_ctx.user.talent.salary.monthly *
                          _ctx.user.meta.mxn_to_usd_exchange_rate) /
                        100
                      ).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })) + " " + _toDisplayString(_ctx.currency), 1))
                                        : _createCommentVNode("", true),
                                      (_ctx.currency === 'mxn')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, " $" + _toDisplayString((_ctx.user.talent.salary.monthly / 100).toLocaleString(
                        undefined,
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                      )) + " " + _toDisplayString(_ctx.currency), 1))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("button", {
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changePage(_ctx.user.talent.nomilinea_profile ? 5 : 3))),
                                  class: "btn-outline-sm mt-3"
                                }, " View emergency contacts "),
                                _hoisted_20,
                                _createElementVNode("div", _hoisted_21, [
                                  _createElementVNode("div", _hoisted_22, [
                                    _hoisted_23,
                                    (_ctx.user.talent.nomilinea_profile)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.user.talent.nomilinea_profile.eMail), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_25, " - "))
                                  ])
                                ]),
                                _hoisted_26,
                                (_ctx.user.talent.nomilinea_profile)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                      _hoisted_28,
                                      _createElementVNode("div", _hoisted_29, [
                                        _createElementVNode("div", _hoisted_30, [
                                          _hoisted_31,
                                          (
                          _ctx.user.talent.nomilinea_profile.Ciudad &&
                          _ctx.user.talent.nomilinea_profile.Estado
                        )
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.user.talent.nomilinea_profile.Ciudad) + ", " + _toDisplayString(_ctx.user.talent.nomilinea_profile.Estado.replaceAll(
                            "_",
                            " "
                          )) + ", México ", 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _hoisted_33
                                      ]),
                                      _createElementVNode("div", _hoisted_34, [
                                        _createElementVNode("div", _hoisted_35, [
                                          _hoisted_36,
                                          (_ctx.user.talent.nomilinea_profile.Telefono)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.user.talent.nomilinea_profile.Telefono), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _hoisted_38
                                      ]),
                                      _createElementVNode("div", _hoisted_39, [
                                        _createElementVNode("div", _hoisted_40, [
                                          _hoisted_41,
                                          (_ctx.user.talent.nomilinea_profile.eMail)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(_ctx.user.talent.nomilinea_profile.eMail), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _hoisted_43
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_44, [
                                  _hoisted_45,
                                  _createElementVNode("div", _hoisted_46, [
                                    _createElementVNode("div", _hoisted_47, [
                                      _hoisted_48,
                                      (_ctx.user.talent.nomilinea_profile)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_49, [
                                            _createVNode(_component_DateFormatter, {
                                              date: _ctx.user.talent.nomilinea_profile.FechaIngreso
                                            }, null, 8, ["date"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _hoisted_50
                                  ]),
                                  _hoisted_51
                                ]),
                                (_ctx.user.talent.candidate)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                      _hoisted_54,
                                      _createElementVNode("p", _hoisted_55, _toDisplayString(_ctx.user.talent.candidate.summary), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.user.talent)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                _createElementVNode("div", _hoisted_57, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navMenu, (btn, i) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: i,
                                      class: "mx-4"
                                    }, [
                                      _createElementVNode("button", {
                                        onClick: ($event: any) => (_ctx.changePage(i)),
                                        class: _normalizeClass(["font-medium capitalize", {
                        'text-black': btn.selected,
                        'text-gray-400': !btn.selected,
                      }])
                                      }, _toDisplayString(btn.name.replaceAll("-", " ")), 11, _hoisted_58)
                                    ]))
                                  }), 128))
                                ]),
                                _hoisted_59,
                                (
                    _ctx.selectedPage === 'timeline' &&
                    _ctx.user.talent.status === 'incoming'
                  )
                                  ? (_openBlock(), _createBlock(_component_Onboarding, {
                                      key: 0,
                                      id: _ctx.user.talent.id,
                                      class: "mt-4"
                                    }, null, 8, ["id"]))
                                  : _createCommentVNode("", true),
                                (_ctx.selectedPage === 'timeline')
                                  ? (_openBlock(), _createBlock(_component_Timeline, {
                                      key: 1,
                                      type: "talent_id",
                                      value: _ctx.user.talent.id,
                                      class: "mt-4"
                                    }, null, 8, ["value"]))
                                  : (_ctx.selectedPage === 'role')
                                    ? (_openBlock(), _createBlock(_component_Position, {
                                        key: 2,
                                        talent: _ctx.user.talent
                                      }, null, 8, ["talent"]))
                                    : (_ctx.selectedPage === 'payment-breakdown')
                                      ? (_openBlock(), _createBlock(_component_PaymentBreakdown, {
                                          key: 3,
                                          talent: _ctx.user
                                        }, null, 8, ["talent"]))
                                      : (_ctx.selectedPage === 'payment-information')
                                        ? (_openBlock(), _createBlock(_component_PaymentInformation, {
                                            key: 4,
                                            id: _ctx.user.talent.id,
                                            department: _ctx.user?.talent?.job?.department,
                                            job_title: _ctx.user.talent.job_title,
                                            entry_day: _ctx.user.talent.created_at,
                                            nomilinea: _ctx.user.talent.nomilinea_profile
                                          }, null, 8, ["id", "department", "job_title", "entry_day", "nomilinea"]))
                                        : (_ctx.selectedPage === 'files')
                                          ? (_openBlock(), _createBlock(_component_Files, { key: 5 }))
                                          : (_ctx.selectedPage === 'emergency-contacts')
                                            ? (_openBlock(), _createBlock(_component_EmergencyContacts, {
                                                key: 6,
                                                talent_id: _ctx.user.talent.id
                                              }, null, 8, ["talent_id"]))
                                            : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
            ]))
      ])
    ])
  ]))
}